import { AxiosResponse } from 'axios';
import { IGetInvoicesPayload } from '../redux/invoice/invoiceSlice';
import { backendApiInstance } from './backendApiInstance';

export async function getInvoices({
  page,
  limit,
  sortBy,
  sortOrder,
  organizationId,
  startDate,
  endDate,
  status,
}: IGetInvoicesPayload): Promise<AxiosResponse> {
  const params = { page, limit, sortBy, sortOrder, organizationId, startDate, endDate, status };
  return backendApiInstance.get('/invoices', { params });
}

export async function getInvoiceByPaymentId(paymentId: string): Promise<AxiosResponse> {
  return backendApiInstance.get(`/invoices/payment/${paymentId}`);
}
